module.exports = __webpack_public_path__ + "static/media/ic_hand_insurance_fisdom.3756a824.svg";